import { useItems } from "atoms/itemAtom";
import { useSetAtom } from "jotai";
import React from "react";
import { setPropertiesProductAtom } from "atoms/modalAtom/modalAtom";

import { Button } from "components/Button/Button";

export function EditProductButton() {
  const setPropertiesProduct = useSetAtom(setPropertiesProductAtom);
  const { itemsState } = useItems();

  const handleClick = () => {
    if (itemsState.checkedItems.length === 1) {
      setPropertiesProduct(true);
    }
  };

  return (
    <Button
      icon="settings"
      onClick={handleClick}
      disabled={itemsState.checkedItems.length !== 1}
    >
      Свойства
    </Button>
  );
}
